import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useGetWidgetAnalysisConfig } from "@/api/widget/useWidgetAPI";
import { RootState } from "@/store";
import { AggregationType, WidgetConfig, WidgetType } from "@/types/widget";
import { mapPostWidgetAnalysisConfigPayload } from "@/utils/widget";

export default function useDatasetWidgetSummary(widget: WidgetConfig) {
  const { filters } = useSelector((state: RootState) => state.dataset);

  const lastIndex = widget.widget_id.lastIndexOf("_");
  const widgetId = widget.widget_id.slice(0, lastIndex);

  const { data: widgetAnalysisResult } = useGetWidgetAnalysisConfig(
    mapPostWidgetAnalysisConfigPayload(widget, filters[widgetId] ?? [])
  );

  const rawData = useMemo(() => {
    return widgetAnalysisResult?.data?.data?.slice(
      0,
      widget.configuration.dimension_values_shown
    );
  }, [widgetAnalysisResult, widget]);

  const bigNumberData = useMemo((): {
    type: AggregationType;
    value: number;
    measure: string;
  } | null => {
    if (widget.chart_type !== WidgetType.BIG_NUMBER) return null;
    if (widgetAnalysisResult?.data?.value) {
      return {
        type:
          (widgetAnalysisResult.data.aggregation as AggregationType) ??
          AggregationType.COUNT,
        value: widgetAnalysisResult.data.value,
        measure: widgetAnalysisResult.data.measure || ""
      };
    }
    return null;
  }, [widgetAnalysisResult, widget]);

  return {
    rawData,
    bigNumberData
  };
}
